<div class="flex flex-col h-full -ml-1">
  <a
    class="appNav-section ml-1"
    [routerLink]="['org', currentOrganization.id, 'projects']"
    routerLinkActive="is-active"
  >
    <span class="appNav-section-icon i i-folders"></span>
    <span class="appNav-menu-title" routerLinkActive="is-active" [routerLinkActiveOptions]="rlao">
      {{ currentOrganization.team_mode ? t("teamModeTitle") : t("singleModeTitle") }}
    </span>
  </a>
  <ng-scrollbar #scrollbarRef [position]="'invertY'" [visibility]="'hover'">
    <div scrollViewport cdkScrollable>
      <div class="appNav-collapsedHidden text-overflow ml-1" cdkDropList (cdkDropListDropped)="drop($event)">
        <a
          *ngFor="let project of projects"
          class="appNav-menu-item"
          [routerLink]="['/org', currentOrganization.id, 'projects', project.project.slug]"
          routerLinkActive="is-active"
          cdkDrag
          cdkDragLockAxis="y"
          [cdkDragDisabled]="isDragDisabled$ | async"
        >
          <span class="appNav-menu-drag i i-grip-vertical"></span>
          <span class="text-overflow" [innerHTML]="project.project.name"></span>
        </a>
      </div>
    </div>
  </ng-scrollbar>
</div>
